<template>
  <modal
    name="createAccount"
    modal-style="compact"
    :display-header-title="false"
  >
    <sign-up />
  </modal>
</template>


<script>
  import SignUp from './sign-up/index.vue';


  export default {
    name: 'SignUpModal',

    components: {
      SignUp
    }
  };
</script>
